import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';
import { Loader2 } from 'lucide-react';

const REASONS = [
  { value: 'too_expensive', label: 'Too expensive' },
  { value: 'missing_features', label: 'Missing features' },
  { value: 'switching', label: 'Switching to another tool' },
  { value: 'not_using', label: 'Not using it enough' },
  { value: 'other', label: 'Other' },
];

export default function CancelSubscriptionDialog({
  open,
  onOpenChange,
  periodEnd,
  isYearly,
  loading,
  onConfirm,
}) {
  const endLabel = periodEnd
    ? new Date(periodEnd).toLocaleDateString(undefined, { dateStyle: 'long' })
    : 'the end of your billing period';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>We&apos;re sorry to see you go</DialogTitle>
          <DialogDescription>Optional: tell us why you&apos;re canceling</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label>Reason (optional)</Label>
            <Select onValueChange={() => {}}>
              <SelectTrigger>
                <SelectValue placeholder="Select a reason" />
              </SelectTrigger>
              <SelectContent>
                {REASONS.map((r) => (
                  <SelectItem key={r.value} value={r.value}>
                    {r.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="rounded-md border border-amber-200 bg-amber-50 dark:bg-amber-950/30 p-3 text-sm text-amber-900 dark:text-amber-100 space-y-2">
            <p>Your subscription stays active until {endLabel}.</p>
            <p>No refund for the current billing period.</p>
            <p>After that date your account switches to read-only. Data is kept for 30 days.</p>
            <p>You can reactivate anytime during that window.</p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={loading}>
            Keep my subscription
          </Button>
          <Button
            variant="destructive"
            disabled={loading}
            onClick={() => onConfirm()}
          >
            {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Cancel at period end
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
